<script setup>
const props = defineProps({ blok: Object })
const target = ref(null)
const targetIsVisible = ref(false)

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }], observerElement) => {
    if (isIntersecting)
      targetIsVisible.value = isIntersecting
  },
)

const textColorClasses = computed(() => {
  switch (props.blok.color) {
    case 'blue':
      return '!text-blue-500'
    case 'green':
      return '!text-green-500'
    case 'primary':
      return '!text-secondary-red-100 '
  }
})
const bgClasses = computed(() => {
  switch (props.blok.theme) {
    case 'transparent':
      return 'bg-transparent'
    case 'light-gray':
      return 'bg-secondary-gray-50'
    case 'dark-navy':
      return 'bg-primary'
    default :
      return 'bg-white'
  }
})

const paddingClasses = computed(() => {
  switch (props.blok.padding) {
    case 'padding-top':
      return 'pt-mobile lg:pt-desktop'
    case 'padding-both':
      return 'py-mobile lg:py-desktop'
    default :
      return 'pb-mobile lg:pb-desktop'
  }
})

const gridClasses = computed(() => {
  switch (props.blok.grid) {
    case '4-grid':
      return '2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2'
    default:
      return 'lg:grid-cols-3 md:grid-cols-2'
  }
})
</script>

<template>
  <div ref="target" :class="[bgClasses, paddingClasses]">
    <div class="container">
      <div
        :class="[targetIsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-15px]', textColorClasses]"
        class="transition-[transform,opacity] duration-700 delay-200 ease-in-out mb-1 text-center text-md font-bold capitalize lg:text-xl md:text-xl sm:text-lg"
      >
        {{ blok.header }}
      </div>
      <h2 
        :class="[targetIsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[15px]']"
        class="transition-[transform,opacity] duration-700 delay-400 ease-in-out mx-auto mb-custom-xl text-center text-3xl font-bold lg:max-w-4xl md:max-w-2xl sm:max-w-xl md:text-4xl xl:text-5xl">
        {{ blok.title }}
      </h2>
      <CardLight :class="gridClasses" :is-visible="targetIsVisible" :card="blok.product" :color="blok.color" />
    </div>
  </div>
</template>
